import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidationErrors } from "@angular/forms";
import { StrengthPasswordService } from "./strength-password.service";
import { PasswordStrengthValidator } from "./password-strength.validator";
import { PasswordTest} from "./password-test.model";

@Component({
  template: `
    <input [disabled]="isDisabled" type="hidden" [value]="value" #pwd (input)="value = pwd.value">
	  <strength-indicator [strength]="currentStrength" [touched]="touched"></strength-indicator>
  `,
  selector: "app-password-strength",
  styles: [`
    input { width: 100%; display: block; }
    :host { display: block;     margin-top: -10px;      margin-left: -3px; }
  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordStrengthComponent),
      multi: true
    }, {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => PasswordStrengthComponent),
    }
  ]
})
export class PasswordStrengthComponent implements ControlValueAccessor {
  _value = "";
  onChange = _ => _;
  currentStrength : PasswordTest;
  isDisabled = false;

  @Input() minStrength = 2;
  @Input() touched = false;
  @Output() publishStength = new EventEmitter<any>();
  constructor(
    private strengthPwdSvc: StrengthPasswordService,
    private validator: PasswordStrengthValidator
  ) {

  }

  validate(control) {
    return this.validator.validate(this.minStrength)(control);
  }

  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val || '';
    this.onChange(this._value);
    this.currentStrength = this.strengthPwdSvc.getStrength(this._value);
    this.publishStength.emit(this.currentStrength);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched() { }

  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
  }

  writeValue(value = "") {
    this.value = value;
  }
}
